__turbopack_context__.v({
  "container": "styles-module__qYchua__container",
  "desktopOnly": "styles-module__qYchua__desktopOnly",
  "header": "styles-module__qYchua__header",
  "mobileOnly": "styles-module__qYchua__mobileOnly",
});
